import React from 'react';
import {
  CContainer,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CCardHeader,
  CBreadcrumb,
  CBreadcrumbItem,
} from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import YarnInputs from '../../components/YarnInputs/YarnInputs';
import { connect } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import { createYarnRequestAction } from '../../store/yarn/yarnActions';

const CreateYarn = ({ createYarnRequest, isLoading, createYarnData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSubmit = (data) => {
    createYarnRequest({ data, navigate });
  };

  const handleCancel = () => {
    navigate('/yarn');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/yarn" onClick={(e) => { e.preventDefault(); handleCancel(); }}>
          {t('yarn')}
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{t('createYarn')}</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader>
              <h4>{t('createYarn')}</h4>
            </CCardHeader>
            <CCardBody>
              <YarnInputs
                onSubmit={handleSubmit}
                onCancel={handleCancel}
                isLoading={isLoading}
                submitResponse={createYarnData}
              />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer?.isLoading || false,
  createYarnData: state.yarnReducer?.createYarnData || null,
});

const mapDispatchToProps = (dispatch) => ({
  createYarnRequest: (payload) => dispatch(createYarnRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateYarn);
